import { useTranslation } from "react-i18next";

import { Feature, FeatureCheckStrategy, useCheckFeatureFlag } from "@sol/features";

import { AdminHome, LearnerHome, ManagerHome, TrainerHome, TutorHome } from "@/widgets/home";

import AnalyticsPage from "../components/AnalyticsPage";
import { PageLayout } from "../components/layouts/PageLayout";
import MetaTitle from "../components/MetaTitle";

const ROLE_HOMES = [
    Feature.HOMEPAGE_TRAINER,
    Feature.HOMEPAGE_LEARNER,
    Feature.HOMEPAGE_MANAGER,
    Feature.HOMEPAGE_TUTOR,
];

const ClassroomHomepage = () => {
    const [t] = useTranslation();
    const checkFeatureFlag = useCheckFeatureFlag();

    // The administration home belongs to users whose only space is the back office.
    // It must be granted by the administration feature, never inferred from a missing role home.
    const showAdminHome =
        checkFeatureFlag(Feature.ADMIN) && checkFeatureFlag(ROLE_HOMES, { strategy: FeatureCheckStrategy.NONE });

    return (
        <>
            <MetaTitle title={t("page.home.meta.title")} />
            <PageLayout title={t("page.home.title")}>
                {checkFeatureFlag(Feature.HOMEPAGE_TRAINER) && <TrainerHome />}
                {checkFeatureFlag(Feature.HOMEPAGE_LEARNER) && <LearnerHome />}
                {checkFeatureFlag(Feature.HOMEPAGE_MANAGER) && <ManagerHome />}
                {checkFeatureFlag(Feature.HOMEPAGE_TUTOR) && <TutorHome />}
                {showAdminHome && <AdminHome />}
                <AnalyticsPage />
            </PageLayout>
        </>
    );
};

export default ClassroomHomepage;
